import { render, staticRenderFns } from "./Fuwulie.vue?vue&type=template&id=569b145c&"
import script from "./Fuwulie.vue?vue&type=script&lang=js&"
export * from "./Fuwulie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports